(function () {
  "use strict";

  var TARGET_PRODUCT_PATHS = [
    "/products/thinkscan-673bt",
    "/products/mucar-783bt",
    "/products/thinkscan-662",
    "/products/thinkcar-thinkscan-689bt-bidirectional-scan-tool",
    "/products/thinkcar-thinkscan-689bt-professional-bidirectional-diagnostic-tool",
    "/products/thinkscan-689bt-pro-obd2-scanner-j2534-topology-mapping",
    "/products/mucar-892bt-automotive-scanner",
    "/products/2025-mucar-892bt-ai-diagnostic-scan-tool-lifetime-free",
    "/products/mucar-892bt-pro-obd2-scanner-j2534-topology-mapping",
    "/products/mucar-bt200-max-ai-diagnostic-bidirectional-obd2-scanner-bluetooth",
    "/products/thinkdiag-2",
    "/products/thinkdiag-2-all-system-bidirectional-obd2-scanner"
  ];
  var ROOT_SELECTOR = "[data-m892-coverage]";
  var SELECTORS = [
    { selector: "[data-m892-make]", label: "vehicle make", placeholder: "Search vehicle make" },
    { selector: "[data-m892-model]", label: "model", placeholder: "Search model" },
    { selector: "[data-m892-year]", label: "model year", placeholder: "Search model year" }
  ];
  var uid = 0;
  var openCombo = null;

  function normalize(value) {
    return String(value || "")
      .toLocaleLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function isTargetRoot(root) {
    var rawUrl = root.getAttribute("data-product-url") || "";
    try {
      return TARGET_PRODUCT_PATHS.indexOf(new URL(rawUrl, window.location.origin).pathname) !== -1;
    } catch (_error) {
      return TARGET_PRODUCT_PATHS.indexOf(rawUrl.split("?")[0]) !== -1;
    }
  }

  function getNativeOptions(select) {
    return Array.prototype.slice.call(select.options || []).filter(function (option) {
      return option.value !== "" && !option.disabled;
    });
  }

  function selectedText(select) {
    var option = select.options && select.selectedIndex >= 0
      ? select.options[select.selectedIndex]
      : null;
    return select.value && option ? option.textContent.trim() : "";
  }

  function placeholderText(select, fallback) {
    var first = select.options && select.options[0];
    var text = first && !first.value ? first.textContent.trim() : "";
    return text || fallback;
  }

  function createSvg(className, pathData) {
    var namespace = "http://www.w3.org/2000/svg";
    var svg = document.createElementNS(namespace, "svg");
    var path = document.createElementNS(namespace, "path");
    svg.setAttribute("class", className);
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("aria-hidden", "true");
    path.setAttribute("d", pathData);
    path.setAttribute("fill", "none");
    path.setAttribute("stroke", "currentColor");
    path.setAttribute("stroke-width", "2");
    path.setAttribute("stroke-linecap", "round");
    path.setAttribute("stroke-linejoin", "round");
    svg.appendChild(path);
    return svg;
  }

  function createCombo(select, config) {
    var wrap = select.closest(".m892cov__select-wrap");
    if (!wrap || select.dataset.searchableSelectReady === "true") return null;
    var productRoot = select.closest(ROOT_SELECTOR);
    var closeHiddenMenu = productRoot && /^(THINKSCAN 673BT|MUCAR 783BT)$/.test(productRoot.dataset.productName || "");

    uid += 1;
    var idBase = "m892search-" + uid;
    var inputId = idBase + "-input";
    var listId = idBase + "-list";

    var combo = document.createElement("div");
    combo.className = "m892search";

    var shell = document.createElement("div");
    shell.className = "m892search__shell";

    var icon = createSvg(
      "m892search__icon",
      "m21 21-4.35-4.35m1.35-5.65a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
    );

    var input = document.createElement("input");
    input.id = inputId;
    input.className = "m892search__input";
    input.type = "text";
    input.inputMode = config.selector.indexOf("year") >= 0 ? "numeric" : "search";
    input.autocomplete = "off";
    input.spellcheck = false;
    input.setAttribute("role", "combobox");
    input.setAttribute("aria-autocomplete", "list");
    input.setAttribute("aria-haspopup", "listbox");
    input.setAttribute("aria-expanded", "false");
    input.setAttribute("aria-controls", listId);
    input.setAttribute("aria-label", "Search and select " + config.label);

    var chevron = document.createElement("span");
    chevron.className = "m892search__chevron";
    chevron.setAttribute("aria-hidden", "true");

    shell.appendChild(icon);
    shell.appendChild(input);
    shell.appendChild(chevron);
    combo.appendChild(shell);

    var panel = document.createElement("div");
    panel.className = "m892search__panel";
    var coverageRoot = select.closest(ROOT_SELECTOR);
    if (coverageRoot) {
      var coverageStyles = window.getComputedStyle(coverageRoot);
      var productAccent = coverageStyles.getPropertyValue("--m892-accent").trim();
      var productAccentSoft = coverageStyles.getPropertyValue("--m892-accent-soft").trim();
      if (productAccent) panel.style.setProperty("--m892search-accent", productAccent);
      if (productAccentSoft) panel.style.setProperty("--m892search-accent-soft", productAccentSoft);
    }
    panel.hidden = true;

    var panelHead = document.createElement("div");
    panelHead.className = "m892search__panel-head";
    var panelTitle = document.createElement("strong");
    panelTitle.textContent = "Select " + config.label;
    var panelCount = document.createElement("span");
    panelHead.appendChild(panelTitle);
    panelHead.appendChild(panelCount);

    var list = document.createElement("ul");
    list.id = listId;
    list.className = "m892search__list";
    list.setAttribute("role", "listbox");
    list.setAttribute("aria-label", "Available " + config.label + " options");

    var empty = document.createElement("p");
    empty.className = "m892search__empty";
    empty.textContent = "No matches found. Try a shorter search.";
    empty.hidden = true;

    var status = document.createElement("span");
    status.className = "m892search__status";
    status.setAttribute("role", "status");
    status.setAttribute("aria-live", "polite");

    panel.appendChild(panelHead);
    panel.appendChild(list);
    panel.appendChild(empty);
    panel.appendChild(status);
    document.body.appendChild(panel);

    wrap.classList.add("m892search--ready");
    select.classList.add("m892search__native");
    select.dataset.searchableSelectReady = "true";
    select.setAttribute("aria-hidden", "true");
    select.tabIndex = -1;
    wrap.appendChild(combo);

    var nativeLabel = select.id
      ? select.closest(".m892cov__field").querySelector('label[for="' + select.id + '"]')
      : null;
    if (nativeLabel) nativeLabel.htmlFor = inputId;

    var state = {
      select: select,
      input: input,
      shell: shell,
      panel: panel,
      list: list,
      empty: empty,
      status: status,
      panelCount: panelCount,
      config: config,
      options: [],
      filtered: [],
      activeIndex: -1,
      open: false,
      typing: false
    };

    function syncFromNative(forceInput) {
      state.options = getNativeOptions(select).map(function (option) {
        return {
          value: option.value,
          label: option.textContent.trim(),
          search: normalize(option.textContent)
        };
      });
      input.disabled = Boolean(select.disabled);
      shell.classList.toggle("is-disabled", input.disabled);
      input.placeholder = select.disabled
        ? placeholderText(select, config.placeholder)
        : config.placeholder;
      if (forceInput || !state.open || !state.typing) input.value = selectedText(select);
      if (state.open) renderOptions();
    }

    function filterOptions() {
      var query = normalize(input.value);
      if (!query || input.value === selectedText(select)) return state.options.slice();
      return state.options
        .filter(function (option) { return option.search.indexOf(query) >= 0; })
        .sort(function (a, b) {
          var aStarts = a.search.indexOf(query) === 0 ? 0 : 1;
          var bStarts = b.search.indexOf(query) === 0 ? 0 : 1;
          return aStarts - bStarts || a.label.localeCompare(b.label);
        });
    }

    function setActive(index, shouldScroll) {
      var items = list.querySelectorAll(".m892search__option");
      if (!items.length) {
        state.activeIndex = -1;
        input.removeAttribute("aria-activedescendant");
        return;
      }
      state.activeIndex = Math.max(0, Math.min(index, items.length - 1));
      Array.prototype.forEach.call(items, function (item, itemIndex) {
        item.classList.toggle("is-active", itemIndex === state.activeIndex);
      });
      var active = items[state.activeIndex];
      input.setAttribute("aria-activedescendant", active.id);
      if (shouldScroll) active.scrollIntoView({ block: "nearest" });
    }

    function choose(option) {
      if (!option) return;
      select.value = option.value;
      input.value = option.label;
      state.typing = false;
      select.dispatchEvent(new Event("input", { bubbles: true }));
      select.dispatchEvent(new Event("change", { bubbles: true }));
      input.focus({ preventScroll: true });
      close(false);
      if (closeHiddenMenu) close(false);
    }

    function renderOptions() {
      state.filtered = filterOptions();
      list.textContent = "";
      empty.hidden = state.filtered.length > 0;
      list.hidden = state.filtered.length === 0;
      panelCount.textContent = state.filtered.length + (state.filtered.length === 1 ? " option" : " options");
      status.textContent = state.filtered.length
        ? state.filtered.length + " matching " + config.label + " options"
        : "No matching " + config.label + " options";

      state.filtered.forEach(function (option, index) {
        var item = document.createElement("li");
        item.id = idBase + "-option-" + index;
        item.className = "m892search__option";
        item.setAttribute("role", "option");
        item.setAttribute("aria-selected", String(option.value === select.value));
        item.dataset.value = option.value;
        var mark = document.createElement("span");
        mark.className = "m892search__option-mark";
        mark.setAttribute("aria-hidden", "true");
        var label = document.createElement("span");
        label.textContent = option.label;
        item.appendChild(mark);
        item.appendChild(label);
        item.addEventListener("click", function (event) {
          event.preventDefault();
          choose(option);
        });
        list.appendChild(item);
      });

      var selectedIndex = state.filtered.findIndex(function (option) {
        return option.value === select.value;
      });
      setActive(selectedIndex >= 0 ? selectedIndex : 0, false);
      positionPanel();
    }

    function positionPanel() {
      if (!state.open) return;
      var rect = shell.getBoundingClientRect();
      var visual = window.visualViewport;
      var viewportTop = visual ? visual.offsetTop : 0;
      var viewportHeight = visual ? visual.height : window.innerHeight;
      var viewportBottom = viewportTop + viewportHeight;
      var gap = 7;
      var below = viewportBottom - rect.bottom - gap - 10;
      var above = rect.top - viewportTop - gap - 10;
      var placeBelow = below >= 210 || below >= above;
      var available = Math.max(150, Math.min(360, placeBelow ? below : above));
      var width = Math.max(220, Math.min(rect.width, window.innerWidth - 20));
      var left = Math.max(10, Math.min(rect.left, window.innerWidth - width - 10));

      panel.style.width = width + "px";
      panel.style.left = left + "px";
      panel.style.maxHeight = available + "px";
      panel.style.top = placeBelow ? rect.bottom + gap + "px" : "auto";
      panel.style.bottom = placeBelow ? "auto" : window.innerHeight - rect.top + gap + "px";
    }

    function open() {
      if (input.disabled || !state.options.length) return;
      if (closeHiddenMenu && !shell.getClientRects().length) return;
      if (openCombo && openCombo !== state && openCombo.close) openCombo.close(true);
      state.open = true;
      openCombo = state;
      state.close = close;
      panel.hidden = false;
      shell.classList.add("is-open");
      input.setAttribute("aria-expanded", "true");
      renderOptions();
      requestAnimationFrame(positionPanel);
    }

    function close(revertInput) {
      if (!state.open) return;
      state.open = false;
      state.typing = false;
      panel.hidden = true;
      shell.classList.remove("is-open");
      input.setAttribute("aria-expanded", "false");
      input.removeAttribute("aria-activedescendant");
      if (revertInput !== false) input.value = selectedText(select);
      if (openCombo === state) openCombo = null;
    }

    input.addEventListener("focus", function () {
      open();
    });

    input.addEventListener("click", function () {
      open();
      if (input.value && input.value === selectedText(select)) input.select();
    });

    input.addEventListener("input", function () {
      state.typing = true;
      open();
      renderOptions();
    });

    input.addEventListener("keydown", function (event) {
      if (event.key === "ArrowDown") {
        event.preventDefault();
        open();
        setActive(state.activeIndex + 1, true);
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        open();
        setActive(state.activeIndex - 1, true);
      } else if (event.key === "Enter" && state.open) {
        event.preventDefault();
        choose(state.filtered[state.activeIndex]);
      } else if (event.key === "Escape" && state.open) {
        event.preventDefault();
        event.stopPropagation();
        close(true);
      } else if (event.key === "Tab") {
        close(true);
      }
    });

    select.addEventListener("change", function () {
      syncFromNative(true);
    });

    var observerQueued = false;
    var observer = new MutationObserver(function () {
      if (observerQueued) return;
      observerQueued = true;
      requestAnimationFrame(function () {
        observerQueued = false;
        syncFromNative(false);
      });
    });
    observer.observe(select, { childList: true, subtree: true, attributes: true, attributeFilter: ["disabled"] });

    state.position = positionPanel;
    state.close = close;
    syncFromNative(true);
    return state;
  }

  function enhanceRoot(root) {
    if (!isTargetRoot(root) || root.dataset.searchableVehicleReady === "true") return;
    root.dataset.searchableVehicleReady = "true";
    var combos = SELECTORS.map(function (config) {
      var select = root.querySelector(config.selector);
      return select ? createCombo(select, config) : null;
    }).filter(Boolean);
    root._m892SearchableCombos = combos;
    if (/^(THINKSCAN 673BT|MUCAR 783BT)$/.test(root.dataset.productName || "")) {
      // Touch selection can restore focus just as the mobile finder hides.
      // Result panels must not retain a menu anchored to a hidden input.
      var resultMenuObserver = new MutationObserver(function () {
        if (root.dataset.hasResults === "true") {
          combos.forEach(function (combo) { combo.close(true); });
        }
      });
      resultMenuObserver.observe(root, { attributes: true, attributeFilter: ["data-has-results"] });
      root._m892ResultMenuObserver = resultMenuObserver;
    }
  }

  function initialize() {
    Array.prototype.forEach.call(document.querySelectorAll(ROOT_SELECTOR), enhanceRoot);
  }

  document.addEventListener("pointerdown", function (event) {
    if (!openCombo) return;
    if (openCombo.panel.contains(event.target) || openCombo.input.contains(event.target)) return;
    openCombo.close(true);
  });

  window.addEventListener("resize", function () {
    if (openCombo && openCombo.position) openCombo.position();
  }, { passive: true });

  window.addEventListener("scroll", function () {
    if (openCombo && openCombo.position) openCombo.position();
  }, { passive: true, capture: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", function () {
      if (openCombo && openCombo.position) openCombo.position();
    }, { passive: true });
    window.visualViewport.addEventListener("scroll", function () {
      if (openCombo && openCombo.position) openCombo.position();
    }, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", initialize);
})();
